const actionsEvent = {
  ON_CONFIRM_RESET_KEY: 'onConfirmResetKey',
  ON_OTP_CLOSE: 'onOtpClose',
  ON_OTP_OPEN: 'onOtpOpen',
  ON_SHOW_API_KEY: 'onShowApiKey',
}

export default actionsEvent
